import { mapGetters, mapActions } from 'vuex'
import { currencyUtil, supplierUtil } from '@/util'

import { ExpansionPanel, TotalAmount } from '@/components/items'
import NormalButton from '@/components/items/Buttons/NormalButton'

import ClientSearch from '@/components/layouts/ClientSearchArea/ClientSearchAreaStorage'
import ClientInfo from '@/components/layouts/ClientInfo/Storage/ClientInfo'
import ProductSearch from '@/components/layouts/ProductSearchArea/ProductSearchAreaStockMove'
import ProductInfo from '@/components/layouts/ProductInfo/Storage/ProductInfo'

import RegisterDialog from '@/components/layouts/Dialogs/MultipleArea/StorageInfoDialog/StorageRegisterDialog'

import DialogAlertError from '@/components/layouts/Dialogs/DialogAlert/DialogAlertError'
import { i18n } from '@/main.js'

export default {
  name: 'Customers',

  components: {
    ExpansionPanel,
    NormalButton,

    ClientSearch,
    ClientInfo,
    ProductSearch,
    ProductInfo,

    TotalAmount,
    RegisterDialog,

    DialogAlertError
  },
  data: () => {
    return {
      pageTitle: i18n.tc('common.common_storage-move'),

      pageType: {
        en: 'sale',
        ja: '注文'
      },

      dialog: {
        dialog: false
      },

      registerData: {
        storage: {},
        client: {},
        product: {
          isHistory: false,
          data: []
        },
        totalList: {
          taxFree: 0,
          tax10: {
            totalAmount: 0,
            tax: 0
          },
          tax8: {
            totalAmount: 0,
            tax: 0
          },
          discount: 0,
          shipping: 0,
          totalAmount: 0,

          unitName: ''
        }
      },

      clientAreaInfo: {
        isOpen: true,
        isSelect: false,
        selectInfo: {}
      },
      selectCurrency: { currencyId: null, name: '', unitName: '' },
      history: {
        productMoves: []
      },

      productSearchInfo: {
        keyword: '',
        category: ''
      },

      errMessage: '',
      errDialog: false
    }
  },
  async created() {
    await supplierUtil.getSupplier()
    await this.getCountryListFromApi()
  },
  methods: {
    ...mapActions('Common', ['getCountryListFromApi']),
    ...mapGetters('Common', ['getCurrencyJpFromState']),

    opnePanel(...args) {
      const [index] = args
      this.clientAreaInfo.isOpen = index.length > 0
    },

    selectStorageRecipient(...args) {
      const [storageRecipient] = args
      // alert(JSON.stringify(storageRecipient))

      const isExist = true
      this.clientAreaInfo = {
        isOpen: isExist,
        isSelect: isExist,
        selectInfo: storageRecipient
      }
    },
    changeClient(...args) {
      const [clientInfo] = args
      this.registerData.storage = clientInfo

      // alert(JSON.stringify(clientInfo))

      // const isExist = clientId in clientInfo
      // this.clientAreaInfo = {
      //   isOpen: isExist,
      //   isSelect: isExist,
      //   selectInfo: clientInfo
      // }

      // const isHistory = type === 'history'
      // this.history.productMoves = isHistory ? clientInfo.productMoves : []
    },
    changeClientInfo(...args) {
      const [clientInfo] = args
      this.registerData.client = clientInfo

      this.updateRegisterDataProductCurrencyId()
    },

    inputKeyword(...args) {
      const [keyword] = args
      this.productSearchInfo.keyword = keyword
    },
    selectCategory(...args) {
      const [categoryId] = args
      this.productSearchInfo.category = categoryId
    },

    changeProductInfo(...args) {
      const [isHistory, productInfo] = args

      this.registerData.product = {
        isHistory: isHistory,
        data: productInfo.filter((ele) => ele.count > 0)
      }
    },
    updateRegisterDataProductCurrencyId() {
      const productData = this.registerData.product.data
      if (!productData.length) return

      this.registerData.product.data = productData.map((ele) => {
        ele.currencyId = this.selectCurrency.currencyId
        return ele
      })
    },

    register() {
      if (
        !this.registerData.storage.ship?.label ||
        !this.registerData.storage.loading?.label
      ) {
        alert(this.$t('common.common_select-storage'))
        // this.errMessage = '顧客を選択してください'
        // this.errDialog = true
        return
      }
      if (!this.registerData.product.data.length) {
        alert(this.$t('product.product_select-product'))
        // this.errMessage = '商品を選択してください'
        // this.errDialog = true
        return
      }
      this.dialog.dialog = true
    }
  },
  watch: {}
}
